<script lang="ts" context="module">
    export type Job = {
        id: number;
        url: string;
        name: string;
        workhtml: string;
        profilhtml: string;
        benefitshtml: string;
        bodyhtml: string;
        locationid: string;
    };
    type JobLocation = {
        id: number;
        name: string;
    };
    export const JobLocations = {
        "1": ["2", "Barsbüttel"],
        "2": ["1", "Greifswald"],
        "3": ["3", "Unna"],
        "4": ["4", "Pforzheim"],
        "5": ["5", "Ludwigsburg"],
    };
</script>

<script lang="ts">
    import { onMount } from "svelte";
    import Container from "../../../components/Container.svelte";
    import Gap from "../../../components/Gap.svelte";
    import LightTheme from "../../../components/LightTheme.svelte";
    import type { News } from "../../../components/NewsCard.svelte";
    import PageTransition from "../../../components/PageTransition.svelte";
    import Image from "../../../components/Image.svelte";
    import Hero from "../../../components/Hero.svelte";
    import IdeaInfo from "../../../components/IdeaInfo.svelte";
    import Divider from "../../../components/Divider.svelte";
    import Headline from "../../../components/Headline.svelte";
    import Btn from "../../../components/Btn.svelte";
    import { params } from "@roxi/routify";
    import Subline from "../../../components/Subline.svelte";
    import ButtonRow from "../../../components/ButtonRow.svelte";
    import { t } from "../../../helpers/translation";

    export let url: string;

    function getJobLocationById(id: number | string) {
        id = "" + id;
        var val = "Unbekannt";
        Object.entries(JobLocations).forEach(([key, value]) => {
            if (value[0] === id) {
                val = value[1];
                return false;
            }
        });
        return val;
    }

    const loadData = async (): Promise<Job> => {
        const data: Job = await fetch(`/api/jobs/${$params.id}/${$params.url}`)
            .then((data) => data.json())
            .then((data) => {
                data.date =
                    new Date(data.startdate).toLocaleDateString() +
                    " - " +
                    new Date(data.enddate).toLocaleDateString();
                return data;
            })
            .catch((err) => console.error(err));

        return data ? Promise.resolve<Job>(data) : Promise.reject(null);
    };
</script>

<LightTheme />

{#await loadData()}
    {$t("fetch.post.loading")}
{:then job}
    <Hero small headline={job.name} />

    <Container max="800px">
        <article>
            <Headline>Deine Tätigkeiten</Headline>
            {@html job.workhtml}

            <Headline>Dein Profil</Headline>
            {@html job.profilhtml}

            <Headline>Deine Benefits</Headline>
            {@html job.benefitshtml}

            <Headline>Standort</Headline>
            <Subline>{getJobLocationById(job.locationid)}</Subline>

            {#if job.bodyhtml}
                <Headline>Sonstiges</Headline>
                {@html job.bodyhtml}
            {/if}
        </article>
        <Gap big />
        <ButtonRow>
            <Btn href="karriere#job-listings" arrow_left icon_left
                >zurück zu den Jobs</Btn
            >
            <Btn href="mailto:personal@sinus-nt.de" icon_left>Kontakt</Btn>
        </ButtonRow>
        <Gap />
    </Container>
{:catch}
    {$t("fetch.post.error")}
{/await}

<style lang="scss">
    @import "../../../vars";
</style>
